import { Box, Grid } from 'components/box';
import { useState } from 'react';
import { Link } from 'components/configurable-routing';
import { css, Theme } from '@emotion/react';
import {
  ChevronDown as IconDownward,
  ChevronUp as IconUpward,
} from 'react-feather';
import Button from 'components/button';

const svgStyles = (theme: Theme) => css`
  height: 30px;
  flex-basis: 24px;
  flex-shrink: 0;
  margin: 0 10px;
  color: ${theme.colors.darkGrey};
`;
const MobileLinks = ({
  title,
  isOpen,
  onClickHandle,
}: {
  title: string;
  isOpen: boolean;
  onClickHandle: () => void;
}) => (
  <div
    css={theme => css`
      @media ${theme.mediaQueries.desktopUp} {
        display: none;
      }
      padding: ${theme.space[2]}px 0;
      background-color: ${theme.colors.black};
      margin-left: -36px;
      margin-right: -36px;
      margin-top: -19px;
      margin-bottom: ${theme.space[3]}px;

      ${title &&
      css`
        margin-left: -16px;
      `}
    `}
  >
    <Button
      margin="0 auto"
      p={0}
      variant="flat"
      type="button"
      pl={title ? 3 : 0}
      size="medium"
      color="white"
      onClick={onClickHandle}
    >
      {title}
      {isOpen ? (
        <IconUpward css={svgStyles} color="white" />
      ) : (
        <IconDownward css={svgStyles} color="white" />
      )}
    </Button>
  </div>
);

const MenuLinks = ({
  slug: activeSlug = '',
  title,
}: {
  slug?: string;
  title?: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Box>
      <Grid
        gridTemplateColumns="1fr"
        gridRowGap={0}
        css={theme => css`
          min-width: 200px;
          font-weight: bold;
          font-family: ${theme.fonts.header};
          margin-right: 20px;
          ${isOpen &&
          css`
            border-bottom: 1px solid ${theme.colors.borderColor};
            margin-bottom: ${theme.space[3]}px;
          `}
          @media screen and (max-width: ${theme.breakpoints.mobile}) {
            display: block;
          }
        `}
      >
        <MobileLinks
          onClickHandle={() => setIsOpen(!isOpen)}
          isOpen={isOpen}
          title={title || ''}
        />
        {[
          ['about-us', 'About us'],
          ['careers', 'Careers', 'https://careers.onedayonly.co.za', '_blank'],
          ['sell-with-us', 'Sell with us'],
        ].map(([slug, title, link, target]) => (
          <Box
            key={slug}
            my={0}
            p={3}
            css={theme => css`
              text-align: center;
              display: none;
              ${isOpen &&
              css`
                display: block;
              `}
              @media ${theme.mediaQueries.desktopUp} {
                display: block;
                text-align: left;
                ${slug === activeSlug &&
                css`
                  border-left: solid 3px ${theme.colors.primary};
                `}
              }
            `}
          >
            <Link
              href={typeof link !== 'undefined' ? link : `/${slug}`}
              target={target}
              color={slug === activeSlug ? 'primary' : 'darkestGrey'}
            >
              {title}
            </Link>
          </Box>
        ))}
      </Grid>
    </Box>
  );
};

export default MenuLinks;
